import useSWR from 'swr';
import '../ui/emergencyPopup.css';

// logic
import { useHistory } from 'react-router-dom';
import { createTicketFormSchema } from '../ticketForm/config/ticketFormSchema';
import ticketService from 'modules/emergencies/ticketService';

const ticketDetailFetcher = async (id) => {
  return ticketService.callBackend.getTicketDetail({ id });
};

// returns ticketDetail with loading/reloading state
const useTicketRepeat = ({ id }) => {
  const { data: ticketDetail, error: ticketDetailError } = useSWR(
    `tickets/${id}/`,
    () => ticketDetailFetcher(id),
    { errorRetryCount: 0, revalidateOnFocus: false, revalidateOnReconnect: false }
  );

  const isLoadingTicketDetail = typeof ticketDetail === 'undefined' && !ticketDetailError;

  const history = useHistory();

  let initialValues = ticketService.defaultValues.getDefaultInitialFormValues();
  if (!isLoadingTicketDetail && !ticketDetailError)
    initialValues = ticketService.dataTransformation.getInitialFormValuesFromTicketDto({
      ticketDto: ticketDetail,
    });

  initialValues.order_data.complementary_info.customer_internal_reference = '';
  const validationSchema = createTicketFormSchema({ isEdit: false });

  const isEdit = false;
  const isReadOnly = false;

  const onSubmit = async ({ ticketDto }) => {
    ticketDto = { ...ticketDto, repeated_from_id: id };
    await ticketService.callBackend.createNewTicket({ ticketDto });
    history.push('/emergencies');
  };

  const onCancel = async () => {
    ticketService.utils.navigateToList({ history });
  };

  return {
    ticketDetail,
    isLoadingTicketDetail,
    ticketDetailError,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    onSubmit,
    onCancel,
  };
};

export default useTicketRepeat;
